export default __webpack_public_path__ + "static/media/new-logo.6c127b78.png";